import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { PacientService } from 'src/services/pacient.service';
import { Util } from '../../../util/util';
import { analyzeAndValidateNgModules } from '@angular/compiler';

@Component({
    selector: 'detalhe-vacina-component',
    templateUrl: 'detalhe-vacina-component.html',
    styleUrls: ['./detalhe-vacina-component.scss']
})

export class DetalheVacinaComponent implements OnInit {

    @Output() onDetalheAtendinento = new EventEmitter();

    @Input() classCSS: string;

    @Input() detalhe: any = {};

    constructor() {
    }

    ngOnInit() {
    }

    getTextFormat(text) {
        return Util.getTextFormat(text);
    }
}
